// extracted by mini-css-extract-plugin
module.exports = {"archive":"Datablock_Archive_archive__EjRnS"};